import {useTranslation} from "react-i18next";

const NonAggregateColumns = [
    'pnoGross',
    'pnoNet',
    'roasGross',
    'roasNet',
    'poasGross',
    'poasNet',
    'ctr',
    'cpm',
    'cpc',
    'profitPercentGross',
    'profitPercentNet',
    'conversionRateGross',
    'conversionRateNet',
];

export default function updateTotal(previous, column, value)
{
    if(value === undefined) {
        value = null;
    }

    if(previous === null || previous === undefined) {
        previous = {};
    }

    if(column.name === 'name') {
        return previous;
    }

    if(previous[column.name] === null) {
        return previous;
    }

    if(NonAggregateColumns.includes(column.name)) {
        let result = {...previous};
        result[column.name] = null;
        return result;
    }

    if(Object.keys(previous).includes(column.name)) {
        previous[column.name] = updateTotalSum(column.name, previous[column.name], value);
    } else {
        previous[column.name] = value;
    }

    return previous;
}

export function updateTotalSum(key, value1, value2) {

    if(value1 === null || value1 === undefined) {
        return null;
    }

    if(value2 === null || value2 === undefined) {
        return null;
    }

    if(
        Object.keys(value1).includes('amount')
        && Object.keys(value1).includes('currency')
        && Object.keys(value2).includes('amount')
        && Object.keys(value2).includes('currency')
    ) {
        return {...value1, amount: (parseInt(value1.amount) + parseInt(value2.amount))};
    }

    return value1 + value2;
}

export function calculateMarketingChannelResults(userSettings, totalRow)
{
    const spendMarketingAmount = Math.max(1, totalRow.spendMarketing?.amount ?? 0);

    if(userSettings?.isMarketing) {
        const turnoverGrossAmount = totalRow.turnoverGross?.amount ?? 0;
        const spendGoodsGrossAmount = totalRow.spendGoodsGross?.amount ?? 0;
        totalRow.pnoGross = (spendMarketingAmount / (turnoverGrossAmount - spendGoodsGrossAmount)) * 100;
    } else {
        const turnoverNetAmount = totalRow.turnoverNet?.amount ?? 0;
        const spendGoodsNetAmount = totalRow.spendGoodsNet?.amount ?? 0;
        totalRow.pnoNet = (spendMarketingAmount / (turnoverNetAmount - spendGoodsNetAmount)) * 100;
    }

    if (totalRow.pnoNet === Number.POSITIVE_INFINITY || totalRow.pnoNet === Number.NEGATIVE_INFINITY)
    {
        totalRow.pnoNet = null;
    }

    if (totalRow.pnoGross === Number.POSITIVE_INFINITY || totalRow.pnoGross === Number.NEGATIVE_INFINITY)
    {
        totalRow.pnoGross = null;
    }

    return totalRow;
}